import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Divider,
} from "@mui/material";
import {
  getShippingRecalculate,
  getShippingSettings,
  updateVendorStateFees,
} from "../../../../services/vendor/vendor.service";
import CubeRateTable from "./CubeRateTable";
import FuelRateTable from "./FuelRateTable";
import { apiURL } from "../../../../config/default";

const ShippingForm = ({ selectedItem, isRender, setIsRender }) => {
  //   console.log("selectedItem", selectedItem?.state);
  const [pickupFee, setPickupFee] = useState(selectedItem?.outSourceFee);
  const [globalCube, setGlobalCube] = useState(selectedItem?.cubeRate);
  const [minimumRate, setMinimumRate] = useState(selectedItem?.minimumRate);
  const [CubeRates, setCubeRates] = useState([]);
  const [FuelRates, setFuelRates] = useState([]);

  const [cubeRate, setCubeRate] = useState(false);
  const [fuelRate, setFuelRate] = useState(false);
  const [nationalCubeRate, setNationalCubeRate] = useState(false);
  const [nationalSurcharge, setNationalSurcharge] = useState(false);
  const [loading, setLoading] = useState(false);
  // 🟢 Snackbar states
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  //   console.log("distributionState", distributionState);

  useEffect(() => {
    getShippingSettings().then((res) => {
      //   console.log("Fetched settings:", res);
      setNationalCubeRate(res.data?.nationalCubeRate || 0);
      setNationalSurcharge(res.data?.nationalSurcharge || 0);
      setCubeRates(res.data?.cubeRates || []);
      setFuelRates(res.data?.feulRates || []);
      if (res.data?.cubeRates?.length > 0) {
        // setDistributionState(res.data.cubeRates[0].state);
      }
    });
  }, []);

  const handleSave = async () => {
    try {
      if (!selectedItem?._id) {
        //    alert("No vendor selected!");
        return;
      }

      const payload = {
        // state: distributionState,
        cubeRate: parseFloat(globalCube) || 0,
        minimumRate: parseFloat(minimumRate) || 0,
        outSourceFee: parseFloat(pickupFee) || 0,
      };

      //   console.log("Saving vendor state fees:", payload);

      const res = await updateVendorStateFees(selectedItem._id, payload);
      //   console.log("resres", res);
      // 🟢 Show success message
      setSnackbar({
        open: true,
        message: res?.message || "Vendor state fees updated successfully!",
        severity: "success",
      });
      //  alert("Vendor state fees updated successfully!");
      setIsRender(!isRender); // re-render parent if needed
    } catch (err) {
      // 🔴 Show error message
      setSnackbar({
        open: true,
        message: "Failed to update vendor state fees.",
        severity: "error",
      });
      //  alert("Failed to update vendor state fees.");
    }
  };

  const handleRecalculateShipping = async () => {
    setLoading(true);
    try {
      const response = await getShippingRecalculate();
      console.log("response", response);

      setSnackbar({
        open: true,
        message: response?.message || "Shipping recalculated successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Error recalculating shipping",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: 0,
        height: "100%",
        borderRadius: 2,
        backgroundColor: "#f0f0f0",
        fontFamily: "sans-serif",
      }}
    >
      {/* 🔔 Snackbar for showing API responses */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {cubeRate ? (
        <CubeRateTable
          cubeRate={cubeRate}
          setCubeRate={setCubeRate}
          initialData={CubeRates}
        />
      ) : fuelRate ? (
        <FuelRateTable
          fuelRate={fuelRate}
          setFuelRate={setFuelRate}
          initialData={FuelRates}
          nationalCubeRate={nationalCubeRate}
          nationalSurcharge={nationalSurcharge}
        />
      ) : (
        <>
          <Box
            sx={{
              padding: 2,
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ paddingTop: 1 }}
            >
              <Grid item xs={8}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  noWrap
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%", // or set a fixed width like "250px"
                  }}
                >
                  Shipping algo: ({selectedItem?.fullName})
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#17a858",
                    color: "white",
                    width: "100%",
                    fontWeight: "bold",
                    borderRadius: "40px",
                    "&:hover": {
                      backgroundColor: "#45a049",
                    },
                  }}
                  onClick={handleSave}
                >
                  save
                </Button>
              </Grid>
            </Grid>
            {/* <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ paddingTop: 2 }}
            >
              <Grid item xs={8}>
                <Typography variant="body2" fontWeight="bold">
                  Distribution Center State
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth size="small">
                  <Select
                    value={distributionState || "select"}
                    onChange={(e) => setDistributionState(e.target.value)}
                    sx={{ backgroundColor: "white", borderRadius: "6px" }}
                  >
                    <MenuItem value="select" disabled>
                      Select
                    </MenuItem>
                    {CubeRates?.map((row) => (
                      <MenuItem key={row.state} value={row.state}>
                        {row.state}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid> */}

            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ paddingTop: 2 }}
            >
              <Grid item xs={8}>
                <Typography variant="body2" fontWeight="bold">
                  Cube Rate
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter"
                  value={
                    globalCube === 0 || globalCube === "0" ? "" : globalCube
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    // ✅ Allow only numbers and one decimal point
                    if (/^\d*\.?\d*$/.test(val)) {
                      setGlobalCube(val);
                    }
                  }}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "lightgray",
                        borderRadius: "6px",
                      },
                      "&:hover fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                    },
                    // ✅ Center both placeholder and input content
                    "& .MuiInputBase-input": {
                      textAlign: "center",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ paddingTop: 2 }}
            >
              <Grid item xs={8}>
                <Typography variant="body2" fontWeight="bold">
                  Minimum Rate
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter"
                  value={
                    minimumRate === 0 || minimumRate === "0" ? "" : minimumRate
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    // ✅ Allow only numbers and one decimal point
                    if (/^\d*\.?\d*$/.test(val)) {
                      setMinimumRate(val);
                    }
                  }}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "lightgray",
                        borderRadius: "6px",
                      },
                      "&:hover fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                    },
                    // ✅ Center both placeholder and input content
                    "& .MuiInputBase-input": {
                      textAlign: "center",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ paddingTop: 2 }}
            >
              <Grid item xs={8}>
                <Typography variant="body2" fontWeight="bold">
                  Outsource Pickup Fee
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter"
                  value={pickupFee === 0 || pickupFee === "0" ? "" : pickupFee}
                  onChange={(e) => {
                    const val = e.target.value;
                    // ✅ Allow only numbers and one decimal point
                    if (/^\d*\.?\d*$/.test(val)) {
                      setPickupFee(val);
                    }
                  }}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "lightgray",
                        borderRadius: "6px",
                      },
                      "&:hover fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black",
                        borderRadius: "6px",
                      },
                    },
                    // ✅ Center both placeholder and input content
                    "& .MuiInputBase-input": {
                      textAlign: "center",
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  width: "85%",
                  borderRadius: 8,
                  borderColor: "#000",
                  color: "black",
                  fontWeight: "bold",
                  backgroundColor: "#fff",
                  "&:hover": {
                    borderColor: "gray",
                    backgroundColor: "#fafafa",
                  },
                }}
                onClick={() => setFuelRate(true)}
              >
                Edit fuel rate table
              </Button>
              <Button
                variant="outlined"
                sx={{
                  width: "85%",
                  borderRadius: 8,
                  borderColor: "#000",
                  color: "#fff",
                  fontWeight: "bold",
                  backgroundColor: "#000",
                  "&:hover": {
                    borderColor: "gray",
                    backgroundColor: "#000",
                  },
                  "&.Mui-disabled":{
                    color:"#fff",
                  }
                }}
                onClick={handleRecalculateShipping}
                disabled={loading} // Optional: disable button while loading
              >
                {loading ? "Calculating..." : "GENERATE METRO RATES"}
              </Button>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ShippingForm;
